"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingItem = exports.SettingConfigurationType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
var SettingConfigurationType;
(function (SettingConfigurationType) {
    SettingConfigurationType["Profile"] = "Profile";
    SettingConfigurationType["Security"] = "Security";
    SettingConfigurationType["Privacy"] = "Privacy";
})(SettingConfigurationType || (exports.SettingConfigurationType = SettingConfigurationType = {}));
exports.SettingItem = (0, react_1.memo)(({ type, isSelected, onClick }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row", alignItems: "center", spacing: 2, width: "100%", sx: {
            paddingX: theme.spacing(4),
            paddingY: theme.spacing(2),
            cursor: "pointer",
            "&:hover": {
                backgroundColor: theme.palette.primary.light,
            },
            backgroundColor: isSelected
                ? theme.palette.primary.light
                : "transparent",
        }, onClick: () => onClick(type), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", color: theme.palette.primary.contrastText, noWrap: true, children: type }) }));
});
exports.SettingItem.displayName = "ProfileItem";
